// Blog posts data
export const blogPosts = [
  {
    id: 1,
    slug: "why-websites-dont-convert",
    title: "Why Most Business Websites Don't Convert (And How to Fix It)",
    metaTitle: "Why Most Business Websites Don't Convert | Web Growth Studio",
    metaDescription: "Discover why most business websites fail to convert visitors into clients — and what you can do to fix it with proven web growth strategies.",
    excerpt: "You can have a beautiful website. You can even have traffic. And still — no leads, no inquiries, no sales. Here's why most business websites fail — and how to fix it.",
    author: "Web Growth Studio",
    date: "2026-01-19",
    readTime: "5 min read",
    category: "Web Design",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800&q=80",
    content: `
## Introduction

You can have a beautiful website.

You can even have traffic.

And still — no leads, no inquiries, no sales.

This is one of the most common problems we see when businesses come to us.

The website looks fine on the surface, but it simply doesn't convert.

Here's why most business websites fail — and how to fix it.

---

## 1. The Website Is Designed for Looks, Not Users

Many websites are built to impress, not to guide.

**Common mistakes:**

- No clear next step for visitors
- Too much text or too many options
- Visitors don't know what to do

💡 A converting website has one clear goal per page — and everything supports that goal.

---

## 2. No Clear Value Proposition Above the Fold

⚡ If a visitor doesn't understand what you do and who it's for in 5 seconds, they leave.

**Your homepage should instantly answer:**

- Who is this for?
- What problem does it solve?
- Why should I trust you?

If that's missing, conversions drop dramatically.

---

## 3. Weak or Missing Calls to Action

"Contact us" is not a strategy.

**High-performing websites use:**

- Clear, benefit-driven CTAs
- Strategic placement throughout pages
- Consistent messaging across all pages

Visitors need to be invited to take action — not left to guess.

---

## 4. Slow Performance and Poor Mobile Experience

Speed and mobile usability are no longer optional.

**If your site:**

- Loads slowly
- Looks broken on mobile
- Feels outdated

💡 You're losing trust before a single word is read.

---

## 5. No SEO or Traffic Strategy Behind the Website

A website without SEO is like a store without a location.

**Even the best-designed site won't convert if:**

- The wrong audience is visiting
- Or no one finds it at all

SEO, content, and structure must work together.

---

## How We Fix This at Web Growth Studio

We don't just build websites — we build growth systems.

**Our approach combines:**

- Conversion-focused design
- Clear messaging and structure
- SEO-driven content
- Performance optimization

Every element has a purpose: to turn visitors into clients.

---

## Final Thoughts

If your website isn't generating results, the problem usually isn't traffic — it's structure.

⚡ A high-converting website is not about trends. It's about clarity, trust, and strategy.
    `
  }
];

export const getBlogPostBySlug = (slug) => {
  return blogPosts.find(post => post.slug === slug);
};
